<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Indicator',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-line-chart-line',
  color: 'warning',
  title: 'Indikator Mutu',
  description: 'Mencatat nilai bulanan indikator dan memantau tren pencapaian target.',
  purpose: 'Panduan mencatat capaian indikator mutu setiap bulan dan membaca grafik trennya.',
  concept: [
    {
      icon: 'ri-target-line',
      title: 'Indikator Punya Target',
      text: 'Setiap indikator (mis. "Angka Infeksi Nosokomial") punya nilai target yang ditentukan sejak awal. Nilai yang Anda catat setiap bulan dibandingkan dengan target itu.',
    },
  ],
  steps: [
    { title: 'Buka menu Mutu → Indikator Mutu', detail: 'Lihat daftar indikator beserta nilai terakhirnya.' },
    { title: 'Klik satu indikator untuk melihat detail dan tren', detail: 'Grafik menampilkan nilai bulan-bulan sebelumnya.' },
    { title: 'Klik "Catat Nilai Bulan Ini"', detail: 'Isi nilai untuk periode berjalan.' },
    { title: 'Klik "Simpan"', detail: 'Grafik tren otomatis diperbarui dengan titik data baru.' },
  ],
  tips: [
    'Catat nilai indikator secara konsisten di tanggal yang sama tiap bulan supaya tren mudah dibandingkan.',
  ],
  faq: [
    { q: 'Kalau saya mencatat ulang nilai bulan yang sama, apa yang terjadi?', a: 'Nilai lama untuk bulan itu ditimpa dengan nilai baru — tidak ada dua nilai untuk bulan yang sama.' },
  ],
  related: [
    { title: 'Dashboard & Laporan', sub: 'Lihat ringkasan indikator lintas unit', icon: 'ri-dashboard-line', color: 'error', to: { name: 'help-administrasi-dashboard-laporan' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
